import React, { useState, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { Roofing, Diversity3, Apps, ShoppingCart, MoneyOff, TrendingUp, Receipt, BlindsClosed, SyncAlt } from "@mui/icons-material";
import apilink from "../apiURL/baseUrls";
import axios from "axios";
import "@fontsource/open-sans"; // Defaults to weight 400
import "@fontsource/open-sans/400.css"; // Specify weight
import "@fontsource/open-sans/400-italic.css"; // Specify weight and style

import "@fontsource/caveat"; // Defaults to weight 400
import "@fontsource/caveat/400.css"; // Specify weight

const Layout = () => {
  const [screen, setScreen] = useState("home");
  const [sick, setSick] = useState(0);
  const navigate = useNavigate();

  const handleNavigation = (route) => {
    setScreen(route);
    navigate("/app/" + route);
  };

  useEffect(() => {
    const getAsyncData = async () => {

      const storedUser = await JSON.parse(
        localStorage.getItem("userData")
      );

    };

    console.log("Layout data");
    //getAsyncData();
  }, []);

  return (
    <>
      <nav
        style={{ paddingInline: "15px" }}
        className="navbar fixed-top navbar-light bg-light"
      >

        <h1
          className="navbar-brand mb-0"
          style={{
            color: "#EA6C82",
            fontFamily: "Open Sans",
            fontSize: "20px"
          }}
        >
          Fusion<b>POS</b>
        </h1>

        <ShoppingCart
          style={{
            color: '#ffffff',
            backgroundColor: '#EA6C82',
            padding: 10,
            width: "50px",
            height: "50px",
            borderRadius: 25,
            border: "4px solid #547FF7", // <-- this is the fix
            fontSize: "40px"
          }}
        />

      </nav>
      <div className="container-fluid">
        <div id="page-home" className="active">
          <div className="block" style={{ marginTop: "80px", marginBottom: "80px" }}>
            {/* <h2>The standard Lorem Ipsum passage, used since the 1500s</h2> */}
            <Outlet />
          </div>
        </div>
      </div>
      <footer className="footer" style={{ borderTop: "3px solid white", height: "65px" }}>
        <div
          id="buttonGroup"
          className="btn-group selectors"
          role="group"
          aria-label="Basic example"
        >
          <button
            id="home"
            type="button"
            className="btn btn-secondary button-active"
          >
            <div
              onClick={() => handleNavigation("home")}
              className="selector-holder"
            >
              <center>
                <Receipt style={screen === "home" ? { color: '#EA6C82' } : { color: '#547FF7' }} />
                <br />
                <span style={screen === "home" ? { color: '#EA6C82', fontFamily: "Open Sans" } : { color: '#547FF7', fontFamily: "Open Sans" }}>Sales</span>
              </center>
            </div>
          </button>
          <button
            id="feed"
            type="button"
            className="btn btn-secondary button-inactive"
          >
            <div
              onClick={() => handleNavigation("summary")}
              className="selector-holder"
            >
              <center>
                <TrendingUp style={screen === "summary" ? { color: '#EA6C82' } : { color: '#547FF7' }} />
                <br />
                <span style={screen === "summary" ? { color: '#EA6C82', fontFamily: "Open Sans" } : { color: '#547FF7', fontFamily: "Open Sans" }}>Summary</span>
              </center>
            </div>
          </button>
          <button
            id="create"
            type="button"
            className="btn btn-secondary button-inactive"
          >
            <div
              className="selector-holder"
            >
              <center>
                <SyncAlt style={screen === "late" ? { color: '#EA6C82' } : { color: '#547FF7' }} />
                <br />
                <span style={screen === "late" ? { color: '#EA6C82', fontFamily: "Open Sans" } : { color: '#547FF7', fontFamily: "Open Sans" }}>Transfers</span>
              </center>
            </div>
          </button>
          <button
            id="account"
            type="button"
            className="btn btn-secondary button-inactive"
          >
            <div
              className="selector-holder"
            >
              <center>
                <BlindsClosed style={screen === "contacts" ? { color: '#EA6C82' } : { color: '#547FF7' }} />
                <br />
                <span style={screen === "contacts" ? { color: '#EA6C82', fontFamily: "Open Sans" } : { color: '#547FF7', fontFamily: "Open Sans" }}>Expenses</span>
              </center>
            </div>
          </button>
          <button
            id="account"
            type="button"
            className="btn btn-secondary button-inactive"
          >
            <div
              onClick={() => handleNavigation("more")}
              className="selector-holder"
            >
              <center>
                <Apps style={screen === "more" ? { color: '#EA6C82' } : { color: '#547FF7' }} />
                <br />
                <span style={screen === "more" ? { color: '#EA6C82', fontFamily: "Open Sans" } : { color: '#547FF7', fontFamily: "Open Sans" }}>More</span>
              </center>
            </div>
          </button>
        </div>
      </footer>
    </>
  );
};

export default Layout;
